import useSWR from "swr";
import { fetcher } from "./fetcher";

const useSVG = ({ ticker }: { ticker: any }): [any, boolean] => {
    const { data: explodeDt, isValidating } = useSWR(
        ticker ? `/api/detail/svg?ticker=${ticker}` : null,
        fetcher, {
        revalidateOnMount: true,
        revalidateOnFocus: false,
    }
    );
    const isValid = !explodeDt && isValidating;
    const data = explodeDt ? [].concat(...explodeDt) : [];
    return [data, isValid];
}
export default useSVG;